// Azure AD B2C configuration for MSAL. Values can be overridden via
// REACT_APP_* environment variables (see .env.example); otherwise they
// fall back to the Khor Developer B2C tenant's known values.

const authority =
  process.env.REACT_APP_B2C_AUTHORITY ||
  "https://khordeveloperb2c.b2clogin.com/khordeveloperb2c.onmicrosoft.com/B2C_1A_signup_signin";

const knownAuthority =
  process.env.REACT_APP_B2C_KNOWN_AUTHORITY || "khordeveloperb2c.b2clogin.com";

const clientId =
  process.env.REACT_APP_B2C_CLIENT_ID || "7585e8a9-cc66-4c1c-8a3f-299ae3798660";

export const msalConfig = {
  auth: {
    clientId,
    authority,
    knownAuthorities: [knownAuthority],
    redirectUri: `${window.location.origin}/auth`,
    // We navigate explicitly based on the `newUser` claim, so don't let
    // MSAL also try to restore the pre-login URL after the redirect.
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

// Authorization code + PKCE flow (MSAL's default for SPAs) — forces the
// B2C credential screen every time, matching the site's previous
// prompt=login links rather than silently reusing an existing session.
export const loginRequest = {
  scopes: ["openid"],
  prompt: "login",
};

export const NEW_USER_REDIRECT_PATH = "/install";
export const EXISTING_USER_REDIRECT_PATH = "/request-access";
